import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Container, Grid, Skeleton, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import getConfig from 'next/config';
import HandsetImageSlider from './HandsetImageSlider';
import HandsetDetails from './HandsetDetails';
import styles from './styles';
import { addHandsetToCart, convertCentToEuro, onload, removeHandsetFromCart } from './handset.util';
import {
  addEquipmentAddOns,
  removeEquipmentAddOns,
  getMobileSecurityAddons,
  addMobileSecurityAddOn,
  removeMobileSecurityAddOn,
} from '../eir-addons/EirAddons.util';
import useLocalStorage, { getLocalStorage, setCode } from '../../hooks/useLocalStorage';
import RootContext from '../../../util/root.context';
import { displayCart } from '../eir-cart/cart.util';
import EirErrorPage from './EirErrorPage';
import EirInsuranceContainer from '../eir-insurance/EirInsuranceContainer';
import EirInformation from '../eir-information/EirInformation';
import StandaloneOfferContainer from '../eir-standalone-handset/StandaloneOfferContainer';
import { removeTariffs } from '../../integration/tariff.api';
import { viewItemAnalytics, selectItemListAnalytics } from '../../../util/gtm';
import { formatInsuranceAddOnsData } from '../../../util/Format.util';
import { getCookie } from '../../hooks/useCookie';
import { handleSimTypeUpdate } from '../eir-simtype-selector/simtypeSelector.util';
import PrepayStandaloneOfferContainer from '../eir-prepay/prepay-handset-details/PrepayStandaloneOfferContainer';
// import HandsetSecondaryBannerCurve from './HandsetSecondaryBannerCurve';

const { publicRuntimeConfig } = getConfig();

const EirHandsetContainer = ({
  title,
  offers,
  discounts,
  cmsData,
  cmsDataPrepay,
  showLoader,
  onPortingChange,
  onOfferSelect,
  addingTariff,
  selectedOfferId,
  onOfferUnSelect,
  selectedBundle,
  setHandsetCode,
  loading,
  setShowLoader,
  OutOfStockImg,
  OutOfStockImgAlt,
  handsetNotFound,
  setHandsetNotFound,
  onPageLoadWhenVarientChanges,
  mobileOffersIncart,
  setMobileOffersIncart,
  coUpgradeButton,
  showInsurance,
  setShowInsurance,
  onPageLoad,
  handsetCode,
}) => {
  const theme = useTheme();
  const router = useRouter();
  const localStore = useLocalStorage();
  // formated selected variant
  const [variant, setSelectedVariant] = useState();
  const [handset, setHandset] = useState();
  const [equipmentSimTypes, setEquipmentSimTypes] = useState();
  const [mobileAddOns, setMobileAddOns] = useState([]);
  const [mobileSecurityAddOns, setMobileSecurityAddOns] = useState([]);
  const [visible, setVisible] = useState(false);
  // const [standaloneHandsetOfferId, setStandaloneHandsetOfferId] = useState(null);
  // common handset informations
  const [handsetInfo, setHandsetInfo] = useState({
    description: '',
    offerId: '',
    model: '',
    brand: '',
    colors: [],
    storages: [],
    variantOutOfStock: false,
  });
  const [specification, setSpecification] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [coMobileChange, setCOMobileChange] = useState(false);
  const [addingHanset, setAddingHandset] = useState(false);
  const [variantInCart, setVariantFromCart] = useState([]);
  const [selection, setSelection] = useState({ color: '', storage: '' });
  const [loadingHandset, setLoadingHandset] = useState(true);
  const [isStandaloneHandset, setIsStandaloneHandset] = useState(false);
  const [isHandsetAvailable, setIsHandsetAvailable] = useState(true);
  const [handsetJourney, setHandsetJourney] = useState(false);
  // const [showInsurance, setShowInsurance] = useState(false);
  const [phoneCost, setPhoneCost] = useState('');
  const [upfrontPrice, setUpdatedUpfrontPrice] = useState(false);
  const [insuranceAdded, setInsuranceAdded] = useState(false);
  const [insuranceAddedCheckbox, setInsuranceAddedCheckbox] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [stockIndex, setStockIndex] = useState();
  const [noScroll, setNoScroll] = useState(true);
  const ref = useRef(null);
  const scrollRef = useRef(null);
  const coScrollNext = useRef(null);
  const [selectedSIMType, setSelectedSIMType] = useState(null);
  const [isPrepayHandset, setIsPrepayHandset] = useState(false);
  const [addons, setAddons] = useState([]);
  // const [showCurve, setShowCurve] = useState(false);

  const graphql = useApolloClient();
  const { state: rootState, dispatch } = useContext(RootContext);

  useEffect(() => {
    try {
      const getData = async () => {
        const mobileSecurityAddonsData = await getMobileSecurityAddons(graphql, 'MOBILE');
        setMobileSecurityAddOns(mobileSecurityAddonsData);
      };
      getData();
    } catch (err) {
      console.error(err);
    }
  }, []);

  const nextStep = () => {
    if (
      localStore.getLocalStorage('portin') === 'true' ||
      localStore.getLocalStorage('STANDALONE_PORTIN') === 'true'
    ) {
      localStore.setLocalStorage('INCOMPLETE_PORTING', true);
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/porting`);
    } else {
      localStore.removeLocalStorage('INCOMPLETE_PORTING');
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
    }
    if (isPrepayHandset) router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/prepay/summary`);
  };
  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const removeTarrif = async () => {
    const prospect =
      getCookie('reference') ||
      localStore.getLocalStorage('REF') ||
      localStore.getLocalStorage('PROSPECTUUID');

    const variables = {
      reference: prospect,
      offerId: Number(localStore.getLocalStorage('HANDSET_BE_OFFERID')),
    };

    if (
      rootState?.cart.offers?.find(
        item => item.id === Number(localStore.getLocalStorage('HANDSET_BE_OFFERID'))
      )
    ) {
      const data = await removeTariffs({ graphql, variables });
      if (data != null && !data.error) {
        console.log('tariff removed', data);
      }
    }
  };
  const addMobile = async (NewOfferId, mobileHandsetCode) => {
    // if ((handsetJourney || !submit) && !addingHanset) {
    if (handsetJourney || !addingHanset) {
      if (NewOfferId && handsetJourney) {
        await removeTarrif();
        // dispatch({ type: 'SET_STANDALONE_CART', payload: false });
      }
      setAddingHandset(true);
      const data = await addHandsetToCart({
        graphql,
        localStorage: localStore,
        catalogCode: mobileHandsetCode || variant?.code,
        offerId: Number(NewOfferId) || Number(handsetInfo.offerId),
        cart: rootState.cart,
      });
      const mobileOffers = rootState.cart.offers.filter(
        offer => offer.baseOffer?.serviceGroup === 'MOBILE'
      );
      const latestMobileOffer = mobileOffers[mobileOffers.length - 1];
      const offerId = latestMobileOffer?.id;
      if (
        (selectedSIMType === 'ALL_IN_1' || selectedSIMType === 'ESIM') &&
        getCookie('cart_Type') !== 'CHANGE_OFFER' &&
        !getCookie('PREPAY_STANDALONE_HANDSET')
      ) {
        await handleSimTypeUpdate({
          SIMType: selectedSIMType,
          offerId,
          offerCode:
            getCookie('cart_Type') === 'CHANGE_OFFER'
              ? latestMobileOffer?.baseOffer?.catalogCode
              : '',
          graphql,
          localStore,
          url: '/shop/mobile/handset',
        });
      }
      selectItemListAnalytics('Billpay_handsets', 'Billpay_handsets', data);
      const handsetPrice = data?.cart?.offers.map(off =>
        off?.equipments?.flat().map(hand => hand.amountVatIncluded.discountedUpFrontAmount)
      );
      const phonePrice = handsetPrice?.flat();
      if (phonePrice?.length === 1) {
        setPhoneCost((phonePrice / 100).toFixed(2));
      } else {
        setPhoneCost((phonePrice[1] / 100).toFixed(2));
      }
      setUpdatedUpfrontPrice(true);

      if (data.cart && !data.error) {
        setSubmit(!submit);
        localStore.removeLocalStorage('BILLPAY_JOURNEY');
        dispatch({ type: 'SET_CART', payload: data.cart });
        setVariantFromCart(handset.variants.filter(va => va.code === variant.code));
        displayCart({
          dispatch,
          localStorage: localStore,
          cart: data.cart,
          // nextMethod: nextStep,
          showNextButton: false,
          disablenNextButton: !!isStandaloneHandset,
        });
        setAddingHandset(false);
        setShowNext(true);
        if (mobileAddOns?.length !== 0) {
          setShowInsurance(true);
          const tempCards = [...mobileAddOns];
          tempCards[0].AddonsSelected = false;
          setMobileAddOns(tempCards);
          setInsuranceAdded(false);
          dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: false } });
          setInsuranceAddedCheckbox(false);
        }
      } else {
        // TODO show notification
        console.log(
          data.error.message
            ? `Notification: ${data.error.message}`
            : 'Something went wrong. Try again!'
        );
        setAddingHandset(false);
      }
    }
  };
  const handleVariantChange = mobileHandsetCode => {
    const hasHandsetInCart = rootState?.cart?.offers.filter(
      offer => offer.equipments.length > 0
    ).length;
    if (localStore.hasValue('STANDALONE_PORTIN')) {
      const case1 = mobileOffersIncart === 0 && hasHandsetInCart === 0;
      const case2 = mobileOffersIncart === 0 && hasHandsetInCart === 1;
      const case3 = mobileOffersIncart === 1 && hasHandsetInCart === 1;
      const case4 = mobileOffersIncart === 1 && hasHandsetInCart === 2;
      if (case1 || case3) {
        onPortingChange(
          JSON.parse(localStore.getLocalStorage('STANDALONE_PORTIN')),
          mobileHandsetCode
        );
      } else if (case2 || case4) {
        onPageLoadWhenVarientChanges(mobileHandsetCode);
        const offerId = selectedOfferId[selectedOfferId.length - 1]?.id;
        addMobile(offerId, mobileHandsetCode);
      }
    } else {
      const case1 = mobileOffersIncart === 0 && hasHandsetInCart === 1;
      const case2 = mobileOffersIncart === 1 && hasHandsetInCart === 2;
      if (case1 || case2) {
        addMobile(null, mobileHandsetCode);
      } else if (getCookie('cart_Type') === 'CHANGE_OFFER') {
        onPageLoadWhenVarientChanges(mobileHandsetCode);
      }
    }
  };
  const format = (variantData, specs) => ({
    code: variantData?.code,
    images: variantData?.images?.map(image => ({
      path: image.path,
      altText: image.altText,
    })),
    color: variantData?.color,
    capacity: variantData?.capacity,
    model: variantData?.model,
    price: variantData?.price > 0 ? convertCentToEuro(parseFloat(variantData?.price)) : 'Free',
    brand: variantData?.manufacturer,
    specs: specs
      ?.map(spec => ({ ...spec, value: spec?.value?.split(' ').join('').trim() }))
      .sort((a, b) => a.sortOrder - b.sortOrder),
    outOfStock: variantData?.stockLevel <= 0,
  });
  const selectVariant = (type, value) => {
    let data = [];
    let updatedInfo = handsetInfo;
    // if color option is clicked
    if (type === 'color') {
      // get all storages available for the color selected
      const storagesAvailable = handset.variants
        .filter(equipment => equipment.color === value)
        .map(equipment => ({
          value: equipment.capacity,
          disable: equipment.stockLevel <= 0,
        }));
      // display the available storages
      updatedInfo = {
        ...handsetInfo,
        storages: storagesAvailable,
      };
      // if selected storage is NOT present in availableStorages, then by default selecting the 1st storage option
      if (!storagesAvailable.map(st => st.value).includes(selection.storage)) {
        data = handset.variants.filter(
          equipment =>
            equipment.color === value && equipment.capacity === storagesAvailable[0].value
        );
        setSelection({ color: value, storage: storagesAvailable[0].value });
      } else {
        data = handset.variants.filter(
          equipment =>
            equipment.color === value && equipment.capacity === storagesAvailable[0].value
        );
        setSelection({ ...selection, color: value, storage: storagesAvailable[0].value });
      }
      setSelectedVariant(format(data[0], specification));
      if (data[0]?.addOns?.length !== 0) {
        setMobileAddOns(formatInsuranceAddOnsData(data[0].addOns));
      }
      setHandsetCode(data[0].code);
    } else if (type === 'storage') {
      setSelection({ ...selection, storage: value });
      data = handset.variants.filter(
        equipment => equipment.color === selection.color && equipment.capacity === value
      );
      updatedInfo = {
        ...handsetInfo,
        // colors: handset.variants
        //   .filter(equipment => equipment.capacity === value)
        //   .map(equipment => ({ color: equipment.color, colorCode: equipment.colorCode })),
      };
      setSelectedVariant(format(data[0], specification));
      if (data[0]?.addOns?.length !== 0) {
        setMobileAddOns(formatInsuranceAddOnsData(data[0].addOns));
      }
      setHandsetCode(data[0].code);
    }
    setSubmit(variantInCart.code && variantInCart.code === data[0]?.code);
    setHandsetInfo({ ...updatedInfo });
    if (data[0].stockLevel <= 0) {
      setIsHandsetAvailable(false);
    } else {
      setIsHandsetAvailable(true);
    }
    handleVariantChange(data[0].code);
  };
  const cartChecker = ({ insuranceAddOnData, sortedCartOffer }) => {
    const defaultStanaloneHandsetOfferId = localStore.getLocalStorage('HANDSET_BE_OFFERID');
    if (!defaultStanaloneHandsetOfferId) {
      // if we have defaultofferid as true it means handset is not added yet.
      // changing the cta to Added for mobileInsurance, same work needs to be done for mobile security once it gets enabled from pcat
      if (sortedCartOffer.equipments[0]?.addOn?.catalogCode) {
        const tempCards = [...insuranceAddOnData];
        const objIndex = insuranceAddOnData.findIndex(
          card => card.code === sortedCartOffer.equipments[0].addOn?.catalogCode
        );
        tempCards[objIndex].AddonsSelected = true;
        setHandsetCode(sortedCartOffer.equipments[0].catalogCode);
        setMobileAddOns(tempCards);
        if (tempCards?.length > 0) setShowInsurance(true);
        setShowNext(true);
        setShowLoader({ ...showLoader, code: ' ' });
        setInsuranceAdded(true);
        setVisible(true);
        dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: true } });
      } else {
        setHandsetCode(sortedCartOffer.equipments[0].catalogCode);
        setMobileAddOns(insuranceAddOnData);
        if (insuranceAddOnData?.length > 0) setShowInsurance(true);
        setShowNext(true);
      }
    }
  };
  const getHandset = async () => {
    setLoadingHandset(true);
    setShowNext(false);
    const {
      handsetInfo: handsetData,
      cart,
      // isHandsetAlreadyInCart,
    } = await onload({
      graphql,
      localStorage: localStore,
      equipmentName: title,
      router,
    });
    if (handsetData) {
      viewItemAnalytics('View_handset', handsetData);
      setHandset(handsetData.handset);
      if (!getLocalStorage('STANDALONE_HANDSET')) {
        dispatch({ type: 'SET_CART', payload: cart });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart,
          nextMethod: nextStep,
          showNextButton: false,
          disablenNextButton: false,
        });
      }
      const simCardType =
        handsetData?.handset?.variants?.find(v => v.simCardTypes)?.simCardTypes || [];
      let equipmentTypes;
      if (simCardType) {
        if (simCardType.includes('NANO') && simCardType.includes('ESIM')) {
          equipmentTypes = 'HYBRID';
        } else if (simCardType.includes('NANO')) {
          equipmentTypes = 'PSIM';
        } else if (simCardType.includes('ESIM')) {
          equipmentTypes = 'ESIM';
        }
        setEquipmentSimTypes(equipmentTypes);
      }

      // setting info which are common for all variant
      setHandsetInfo({
        description: handsetData?.handset.description,
        offerId: handsetData?.cartOfferID,
        model: handsetData?.handset.model,
        brand: handsetData?.handset.manufacturer,
        colors: [
          ...new Set(
            handsetData?.handset.variants.map(v =>
              JSON.stringify({
                color: v.color,
                colorCode: v.colorCode,
              })
            )
          ),
        ].map(color => JSON.parse(color)),
        storages: handsetData?.handset?.variants
          ?.filter(p => handsetData?.handset.variants[0].color === p.color)
          .map(s => ({ value: s.capacity, disable: s.stockLevel <= 0 })),
      });

      // common specification for all handset variant
      // ? what if handset with higher capacity has different RAM size??
      setSpecification(handsetData?.handset.specifications);

      // CASE: if an equimpment already present in the mobile offer.
      const sortedCartOffer = [...cart.offers]
        ?.filter(
          offer => offer.baseOffer.serviceGroup === 'MOBILE' && offer.baseOffer.simOnly === false
        )
        .sort((a, b) => b.id - a.id)[0];
      let equipmentInCart = sortedCartOffer?.equipments;
      if (equipmentInCart?.length > 0) {
        const equipmentCode = equipmentInCart[0].catalogCode;
        equipmentInCart = format(
          handsetData.handset.variants.filter(va => va.code === equipmentCode)[0]
        );
        setVariantFromCart(equipmentInCart);
        if (!handsetJourney) {
          displayCart({
            dispatch,
            localStorage: localStore,
            cart,
            nextMethod: nextStep,
            showNextButton: false,
            disablenNextButton: false,
          });
        }
      }
      // TODO if variantFromCart is same as variant (user selected) then,
      // the submit button should show 'Added to cart' message
      if (
        !!equipmentInCart &&
        Object.keys(equipmentInCart).length !== 0 &&
        getCookie('cart_Type') !== 'CHANGE_OFFER' &&
        !localStore.getLocalStorage('STANDALONE_HANDSET')
      ) {
        setSubmit(true);
        if (!handsetJourney) {
          displayCart({
            dispatch,
            localStorage: localStore,
            cart,
            nextMethod: nextStep,
            showNextButton: false,
            disablenNextButton: false,
          });
        }
        setSelectedVariant(equipmentInCart);
        setSelection({
          color: equipmentInCart.color,
          storage: equipmentInCart.capacity,
        });
        setHandsetInfo({
          description: handsetData?.handset.description,
          offerId: handsetData?.cartOfferID,
          model: handsetData?.handset.model,
          brand: handsetData?.handset.manufacturer,
          colors: [
            ...new Set(
              handsetData?.handset.variants.map(v =>
                JSON.stringify({
                  color: v.color,
                  colorCode: v.colorCode,
                })
              )
            ),
          ].map(color => JSON.parse(color)),
          storages: handsetData?.handset?.variants
            ?.filter(p => equipmentInCart.color === p.color)
            .map(s => ({ value: s.capacity, disable: s.stockLevel <= 0 })),
        });
        setHandsetCode(equipmentInCart.code);
        if (getCookie('cart_Type') === 'CHANGE_OFFER') {
          setCOMobileChange(true);
        }
        const insuranceAddOnData = formatInsuranceAddOnsData(
          handsetData?.handset.variants.filter(eq => eq.code === equipmentInCart?.code)[0]?.addOns
        );
        await onPageLoad(equipmentInCart.code);
        cartChecker({ cart, handsetData, insuranceAddOnData, sortedCartOffer });
      } else {
        let cheapestAvailableVariant = handsetData?.handset.variants.filter(
          eq => eq.stockLevel > 0
        )[0];
        if (!cheapestAvailableVariant) {
          setIsHandsetAvailable(false);
          cheapestAvailableVariant = handsetData?.handset.variants[0];
        }
        if (cheapestAvailableVariant.addOns?.length !== 0) {
          setMobileAddOns(formatInsuranceAddOnsData(cheapestAvailableVariant.addOns));
        }
        // set default selected variant as the formatted lowset price variant
        setSelectedVariant(format(cheapestAvailableVariant, handsetData?.handset.specifications));
        // set default seelected color and storage capacity.
        setSelection({
          color: cheapestAvailableVariant.color,
          storage: cheapestAvailableVariant.capacity,
        });
        setHandsetInfo({
          description: handsetData?.handset.description,
          offerId: handsetData?.cartOfferID,
          model: handsetData?.handset.model,
          brand: handsetData?.handset.manufacturer,
          colors: [
            ...new Set(
              handsetData?.handset.variants.map(v =>
                JSON.stringify({
                  color: v.color,
                  colorCode: v.colorCode,
                })
              )
            ),
          ].map(color => JSON.parse(color)),
          storages: handsetData?.handset?.variants
            ?.filter(p => cheapestAvailableVariant.color === p.color)
            .map(s => ({ value: s.capacity, disable: s.stockLevel <= 0 })),
        });
        setHandsetCode(cheapestAvailableVariant.code);
        if (
          getCookie('cart_Type') === 'CHANGE_OFFER' &&
          localStore.getLocalStorage('STANDALONE_HANDSET')
        ) {
          onPageLoadWhenVarientChanges(cheapestAvailableVariant.code);
          if (equipmentInCart?.code) {
            setCOMobileChange(true);
          }
        } else await onPageLoad(cheapestAvailableVariant.code);
      }
      if (rootState?.cart === null) {
        setMobileOffersIncart(cart?.offers?.filter(offer => offer.equipments.length > 0).length);
      }
    } else {
      setHandsetNotFound(true);
    }

    setLoadingHandset(false);
  };
  const addMobileSecurity = async (serviceGroup, catalogCode) => {
    setShowLoader({ ...showLoader, code: catalogCode });
    const data = await addMobileSecurityAddOn(graphql, catalogCode, rootState?.cart);
    if (data !== null && !data.error) {
      dispatch({ type: 'SET_CART', payload: data });

      displayCart({
        dispatch,
        localStorage: localStore,
        graphql,
        cart: data,
        showNextButton: false,
      });
      // changing the cta to Added
      if (serviceGroup === 'MOBILE') {
        const tempCards = [...mobileSecurityAddOns];
        const objIndex = mobileSecurityAddOns.findIndex(card => card.code === catalogCode);
        tempCards[objIndex].AddonsSelected = true;
        setMobileSecurityAddOns(tempCards);
        setShowLoader({ ...showLoader, code: ' ' });
      }
    } else {
      setShowLoader({ ...showLoader, code: ' ' });
    }
  };
  const removeMobileSecurity = async (serviceGroup, catalogCode) => {
    setShowLoader({ ...showLoader, code: catalogCode });
    const data = await removeMobileSecurityAddOn(graphql, catalogCode, rootState?.cart);
    if (data !== null && !data.error) {
      dispatch({ type: 'SET_CART', payload: data });
      displayCart({
        dispatch,
        localStorage: localStore,
        graphql,
        cart: data,
        showNextButton: false,
      });
      // changing the cta to Add
      if (serviceGroup === 'MOBILE') {
        const tempCards = [...mobileSecurityAddOns];
        const objIndex = mobileSecurityAddOns.findIndex(card => card.code === catalogCode);
        tempCards[objIndex].AddonsSelected = false;
        setMobileSecurityAddOns(tempCards);
        setShowLoader({ ...showLoader, code: ' ' });
      }
    } else {
      setShowLoader({ ...showLoader, code: ' ' });
    }
  };

  const addAddon = async (serviceGroup, catalogCode) => {
    setShowLoader({ ...showLoader, code: catalogCode });
    const data = await addEquipmentAddOns(graphql, catalogCode, variant, rootState?.cart);
    if (data != null && !data.error) {
      dispatch({ type: 'SET_CART', payload: data });
      displayCart({
        dispatch,
        localStorage: localStore,
        graphql,
        cart: data,
        showNextButton: false,
      });
      // changing the cta to Added
      if (serviceGroup === 'MOBILE') {
        const tempCards = [...mobileAddOns];
        const objIndex = mobileAddOns.findIndex(card => card.code === catalogCode);
        tempCards[objIndex].AddonsSelected = true;
        setMobileAddOns(tempCards);
        setShowLoader({ ...showLoader, code: ' ' });
        setInsuranceAdded(true);
        setVisible(true);
        dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: true } });
      }
    } else {
      setShowLoader({ ...showLoader, code: ' ' });
    }
  };
  const removeAddOn = async (serviceGroup, catalogCode) => {
    setShowLoader({ ...showLoader, code: catalogCode });
    const data = await removeEquipmentAddOns(graphql, variant, rootState?.cart);
    if (data != null && !data.error) {
      dispatch({ type: 'SET_CART', payload: data });
      displayCart({
        dispatch,
        localStorage: localStore,
        graphql,
        cart: data,
        showNextButton: false,
      });
      // changing the cta to Add
      if (serviceGroup === 'MOBILE') {
        const tempCards = [...mobileAddOns];
        const objIndex = mobileAddOns.findIndex(card => card.code === catalogCode);
        tempCards[objIndex].AddonsSelected = false;
        setMobileAddOns(tempCards);
        setShowLoader({ ...showLoader, code: ' ' });
        setInsuranceAdded(false);
        dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: false } });
        setInsuranceAddedCheckbox(false);
      }
    } else {
      setShowLoader({ ...showLoader, code: ' ' });
    }
  };
  const upgradeChangeOfferMobile = async NewOfferId => {
    const data = await addHandsetToCart({
      graphql,
      localStorage: localStore,
      catalogCode: variant?.code,
      offerId: NewOfferId,
      cart: rootState.cart,
    });
    selectItemListAnalytics('Billpay_handsets', 'Billpay_handsets', data);
    const handsetPrice = data?.cart?.offers.map(off =>
      off?.equipments?.flat().map(hand => hand.amountVatIncluded.discountedUpFrontAmount)
    );
    const phonePrice = handsetPrice?.flat();
    if (phonePrice.length === 1) {
      setPhoneCost((phonePrice / 100).toFixed(2));
    } else {
      setPhoneCost((phonePrice[1] / 100).toFixed(2));
    }
    setUpdatedUpfrontPrice(true);

    if (data.cart && !data.error) {
      dispatch({ type: 'SET_CART', payload: data.cart });
      localStore.removeLocalStorage('HANDSET_BE_OFFERID');
      setVariantFromCart(handset.variants.filter(va => va.code === variant.code));
      displayCart({
        dispatch,
        localStorage: localStore,
        cart: data.cart,
        showNextButton: false,
        disablenNextButton: !!isStandaloneHandset,
      });
    } else {
      // TODO show notification
      console.log(
        data.error.message
          ? `Notification: ${data.error.message}`
          : 'Something went wrong. Try again!'
      );
    }
  };
  const handleAddHandsetForChangeOffer = async () => {
    if (getLocalStorage('STANDALONE_HANDSET')) {
      upgradeChangeOfferMobile(parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10));
    } else {
      addMobile();
    }
    localStore.removeLocalStorage('INCOMPLETE_PORTING');
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
  };
  const handleChangeHandsetForChangeOffer = async () => {
    setCOMobileChange(false);
    if (getCookie('cart_Type') === 'CHANGE_OFFER') {
      if (!variant?.outOfStock) {
        const coOfferId = rootState?.cart?.offers[0].id;
        const data = await removeHandsetFromCart({
          graphql,
          localStorage: localStore,
          equipmentId: JSON.stringify(rootState?.cart?.offers[0].equipments[0].id),
          offerId: JSON.stringify(coOfferId),
        });
        if (data) {
          addMobile();
          localStore.removeLocalStorage('INCOMPLETE_PORTING');
          router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
        }
      }
    }
  };

  useEffect(() => {
    if (title) getHandset();
    else setLoadingHandset(true);
  }, [title]);

  useEffect(() => {
    if (getCookie('cart_Type') === 'CROSS_SELL') {
      setCode('CS');
    }
    if (getCookie('cart_Type') === 'CHANGE_OFFER') {
      setCode('CO');
    }
    if (localStore.getLocalStorage('STANDALONE_HANDSET') || getCookie('STANDALONE_HANDSET')) {
      setShowInsurance(false);
      setHandsetJourney(
        localStore.getLocalStorage('STANDALONE_HANDSET') ||
          getCookie('PREPAY_STANDALONE_HANDSET') === 'true'
      );
      if (!localStore.getLocalStorage('STANDALONE_PORTIN')) {
        setIsStandaloneHandset(false);
      }
      if (getCookie('cart_Type') === 'CHANGE_OFFER') {
        setIsStandaloneHandset(true);
      }
    }
  }, []);

  useEffect(() => {
    if (localStore.getLocalStorage('STANDALONE_HANDSET') && selectedOfferId) {
      localStore.removeLocalStorage('HANDSET_BE_OFFERID');
      const offerId = selectedOfferId[selectedOfferId.length - 1]?.id;
      addMobile(offerId);
    }
  }, [selectedOfferId]);

  useEffect(() => {
    if (scrollRef.current && mobileAddOns?.length > 0 && !visible)
      scrollRef.current.scrollIntoView();
  }, [mobileAddOns, showInsurance]);

  // useEffect(() => {
  //   if (showInsurance) {
  //     setShowCurve(true);
  //   } else if (getLocalStorage('STANDALONE_PORTIN')) {
  //     setShowCurve(true);
  //   }
  // }, [getLocalStorage('STANDALONE_PORTIN'), showInsurance]);

  useEffect(() => {
    if (
      getCookie('cart_Type') === 'CHANGE_OFFER' &&
      localStore.getLocalStorage('STANDALONE_HANDSET') &&
      offers.length > 0 &&
      noScroll
    ) {
      setNoScroll(false);
    } else {
      if (ref.current) ref.current.scrollIntoView({ behavior: 'smooth' });
      if (coScrollNext.current) coScrollNext.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [offers]);
  useEffect(() => {
    if (coScrollNext.current) coScrollNext.current.scrollIntoView({ behavior: 'smooth' });
  }, [showNext]);

  useEffect(() => {
    setStockIndex(handsetInfo.storages.findIndex(res => res.value === selection.storage));
  });
  return (
    <Container disableGutters sx={styles(theme).container}>
      {handsetNotFound ? (
        <Grid container textAlign='center'>
          <Grid item xs={12}>
            <EirErrorPage
              title='Page Not Found'
              description='We still have lots of plans, promotions and services for you.'
              subtext='Go to our homepage to find some links that you may find helpful.'
              ctaText='Go to homepage'
            />
          </Grid>
        </Grid>
      ) : (
        <Grid container justifyContent='center' sx={styles(theme).containerSlider}>
          {/* Breadcrumb - Yet to decide */}
          {/* <Grid item xs={0} sm={12} sx={{ mb: 1 }}>
            <Breadcrumbs>
              <Skeleton width={40} />
              <Skeleton width={40} />
              <Skeleton width={40} />
            </Breadcrumbs>
          </Grid> */}
          <Grid container sx={{ maxWidth: '1200px', p: { md: '2rem 0rem 0 0rem' } }}>
            <Grid item xs={12} md={6.5}>
              <HandsetImageSlider
                variant={variant}
                loadingHandset={loadingHandset}
                loading={loading}
                variantOutOfStock={handsetInfo.variantOutOfStock}
                OutOfStockImg={OutOfStockImg}
                OutOfStockImgAlt={OutOfStockImgAlt}
              />
            </Grid>
            <Grid item xs={12} md={5.5} sx={styles(theme).handsetDetails}>
              <HandsetDetails
                upfrontPrice={upfrontPrice}
                variant={variant}
                loadingHandset={loadingHandset}
                loading={loading}
                handsetInfo={handsetInfo}
                selected={selection}
                onPortingChange={onPortingChange}
                selectVariant={selectVariant}
                setIsStandaloneHandset={setIsStandaloneHandset}
                handleClick={handleClick}
                isStandaloneHandset={isStandaloneHandset}
                handsetJourney={handsetJourney}
                phoneCost={phoneCost}
                selectedSIMType={selectedSIMType}
                setSelectedSIMType={setSelectedSIMType}
                equipmentSimTypes={equipmentSimTypes}
                cmsData={cmsData}
                setIsPrepayHandset={setIsPrepayHandset}
                handsetCode={handsetCode}
                addons={addons}
                setAddons={setAddons}
              />
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              background: theme.palette.secondary.contrastText,
              // showInsurance || isStandaloneHandset
              //   ? theme.palette.primary.lightGrey
              //   : theme.palette.secondary.contrastText,
              pb: showInsurance ? 0 : '4.75rem',
              ...styles(theme).afterCurveContainer,
            }}
          >
            {/* {showCurve && <HandsetSecondaryBannerCurve cmsData={cmsData?.data} />} */}
            {!handsetJourney && !showInsurance && !showNext && !loadingHandset && (
              <Grid item xs={12} sx={styles(theme).addHandsetCtaContainer}>
                <Button
                  variant='buttonMedium'
                  sx={styles(theme).ctastyle2DisableHandsets}
                  onClick={
                    getCookie('cart_Type') !== 'CHANGE_OFFER'
                      ? addMobile
                      : handleAddHandsetForChangeOffer
                  }
                  disabled={
                    getCookie('PREPAY_STANDALONE_HANDSET') && getCookie('PREPAY_STANDALONE_PORTIN')
                      ? stockIndex !== undefined && handsetInfo.storages[stockIndex]?.disable
                      : (stockIndex !== undefined && handsetInfo.storages[stockIndex]?.disable) ||
                        (getCookie('cart_Type') !== 'CHANGE_OFFER'
                          ? selectedSIMType === null && equipmentSimTypes !== 'PSIM'
                          : equipmentSimTypes === null)
                  }
                  aria-label={
                    getCookie('cart_Type') !== 'CHANGE_OFFER' ? 'Add handset' : 'Add to cart'
                  }
                >
                  {getCookie('cart_Type') !== 'CHANGE_OFFER' ? 'Add handset' : 'Add to cart'}
                </Button>
              </Grid>
            )}

            {coMobileChange && (
              <Grid item xs={12} sx={styles(theme).addchangeHandsetCtaContainer}>
                <Button
                  variant='buttonMedium'
                  sx={styles(theme).ctastyle2DisableHandsets}
                  onClick={handleChangeHandsetForChangeOffer}
                  disabled={
                    getCookie('PREPAY_STANDALONE_HANDSET')
                      ? stockIndex !== undefined && handsetInfo.storages[stockIndex]?.disable
                      : (stockIndex !== undefined && handsetInfo.storages[stockIndex]?.disable) ||
                        (getCookie('cart_Type') !== 'CHANGE_OFFER'
                          ? selectedSIMType === null && equipmentSimTypes !== 'PSIM'
                          : equipmentSimTypes === null)
                  }
                  aria-label={
                    getCookie('cart_Type') !== 'CHANGE_OFFER' ? 'Add handset' : 'Add to cart'
                  }
                >
                  {getCookie('cart_Type') !== 'CHANGE_OFFER' ? 'Add handset' : 'Add to cart'}
                </Button>
              </Grid>
            )}

            {isStandaloneHandset && isHandsetAvailable && (
              <Grid
                item
                xs={12}
                sx={{ pt: 5, background: theme.palette.secondary.contrastText }}
                ref={ref}
              >
                <StandaloneOfferContainer
                  cmsData={cmsData}
                  loading={loading}
                  offers={offers}
                  discounts={discounts}
                  onPortingChange={onPortingChange}
                  selectedBundle={selectedBundle}
                  onOfferSelect={onOfferSelect}
                  onOfferUnSelect={onOfferUnSelect}
                  addingTariff={addingTariff}
                  setIsStandaloneHandset={setIsStandaloneHandset}
                  showLoader={showLoader}
                  isStandaloneHandset
                />
              </Grid>
            )}

            {isPrepayHandset && (
              <Grid
                item
                xs={12}
                sx={{ pt: 5, background: theme.palette.secondary.contrastText }}
                ref={ref}
              >
                <PrepayStandaloneOfferContainer
                  cmsDataPrepay={cmsDataPrepay}
                  loading={loading}
                  handsetCode={handsetCode}
                  loadingHandset={loadingHandset}
                  addons={addons}
                  setAddons={setAddons}
                  setShowNext={setShowNext}
                />
              </Grid>
            )}

            {showInsurance && getCookie('cart_Type') !== 'CHANGE_OFFER' && (
              <Grid
                item
                xs={12}
                sx={{
                  pt: isStandaloneHandset ? 0 : 5,
                  ...styles(theme).addOnsContainer,
                }}
                ref={scrollRef}
              >
                <EirInformation
                  title={cmsData?.data?.attributes?.EirInformation_Insurance?.title}
                  description={cmsData?.data?.attributes?.EirInformation_Insurance?.description}
                  textAlign={cmsData?.data?.attributes?.EirInformation_Insurance?.textAlign}
                  useH1={cmsData?.attributes?.EirInformation_Insurance?.useH1}
                  style={{
                    title: { mt: 0 },
                  }}
                />
                <EirInsuranceContainer
                  InsuranceHeading={
                    cmsData?.data?.attributes?.EirInformation_Handset_Insurance_Heading
                  }
                  SecurityHeading={cmsData?.data?.attributes?.MobileSecurityAddonModalTitle}
                  InsuranceList={cmsData?.data?.attributes?.InsuranceList}
                  SecurityList={cmsData?.data?.attributes?.AddonList}
                  mobileAddOns={mobileAddOns}
                  mobileSecurityAddOns={mobileSecurityAddOns}
                  showLoader={showLoader}
                  isHandset
                  addAddon={addAddon}
                  removeAddOn={removeAddOn}
                  addMobileSecurityAddOn={addMobileSecurity}
                  removeMobileSecurityAddOn={removeMobileSecurity}
                  insuranceAdded={insuranceAdded}
                  insuranceAddedCheckbox={insuranceAddedCheckbox}
                  setInsuranceAddedCheckbox={setInsuranceAddedCheckbox}
                  dispatch={dispatch}
                />
              </Grid>
            )}
            {showNext && getCookie('cart_Type') !== 'CHANGE_OFFER' && (
              <Grid item xs={12} sx={styles(theme).ctaContainer}>
                {loadingHandset && <Skeleton height={40} width={150} />}
                {!loadingHandset &&
                  (variant?.outOfStock ? (
                    <Typography sx={{ color: theme.palette.error.main, ml: 4 }}>
                      This variant is currently out of stock.
                    </Typography>
                  ) : (
                    <Button
                      variant='buttonMedium'
                      disabled={insuranceAdded ? !insuranceAddedCheckbox : false}
                      sx={{
                        ...styles(theme).ctaNext,
                        // boxShadow:
                        //   insuranceAdded && !insuranceAddedCheckbox
                        //     ? ''
                        //     : `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px  ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
                      }}
                      onClick={() => {
                        nextStep();
                      }}
                      aria-label='Proceed to review your order'
                    >
                      Next
                      <ArrowForwardIcon sx={{ ml: 1 }} />
                    </Button>
                  ))}
              </Grid>
            )}
            {showNext &&
              getCookie('cart_Type') === 'CHANGE_OFFER' &&
              localStore.getLocalStorage('STANDALONE_HANDSET') && (
                <Grid item xs={12} sx={styles(theme).ctaContainer} ref={coScrollNext}>
                  {loadingHandset && <Skeleton height={40} width={150} />}
                  {!loadingHandset && (
                    <Button
                      variant='buttonMedium'
                      sx={{
                        ...styles(theme).ctaNext,
                        // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px  ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
                      }}
                      onClick={() => {
                        nextStep();
                      }}
                      aria-label='Proceed to review your order'
                    >
                      Next
                      <ArrowForwardIcon sx={{ ml: 1 }} />
                    </Button>
                  )}
                </Grid>
              )}
            {coUpgradeButton && getCookie('cart_Type') === 'CHANGE_OFFER' && !addingTariff && (
              <Grid item xs={12} sx={styles(theme).ctaContainer}>
                {loadingHandset && <Skeleton height={40} width={150} />}
                {!loadingHandset && (
                  <Button
                    variant='buttonMedium'
                    sx={{
                      ...styles(theme).ctaNext,
                      // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px  ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
                    }}
                    onClick={() => {
                      handleAddHandsetForChangeOffer();
                    }}
                    aria-label='Upgrade'
                  >
                    Upgrade
                  </Button>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default EirHandsetContainer;
